import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import SchoolClass from '@/domains/school/class-list/main';

export default {
	name: 'EvaluationQuestionFilter',
	computed: {
		...mapGetters([
			'getClass',
			'getLoggedUser'
		]),
		formIsValid() {
			return this.getClass && this.getClass.schoolClassId;
		}
	},
	components: {
		SchoolClass
	},
	methods: {
		...mapActions([
			'getEvaluationQuestion'
		]),
		onSubmit() {

			if (this.formIsValid) {

				this.getEvaluationQuestion({
					userId: this.getLoggedUser.id,
					schoolClassId: this.getClass.schoolClassId
				}).then((response) => EventBus.$emit('evaluationQuestionFetched', response.data));

			}

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/evaluation/questions-filter/index.js